import React, { Component } from 'react';
import { renderToString } from 'react-dom/server';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Preloader from '../../components/Preloader/Preloader';
import { GetTopic, GetCategoriesList, GetComments, ForumSearch } from '../../utils/api/services/forum';
import paths from '../../paths';
import BreadCrumbs from '../../components/BreadСrumbs/BreadСrumbs';
import SimpleSearch from '../../components/Search/SimpleSearch';
import CustomDropdownForum from '../../components/Inputs/CustomDropdownForum';
import ForumHeaderDesktop from './ForumHeaderDesktop';
import ForumHeaderMobile from './ForumHeaderMobile';
import ForumTopicFirstPost from './ForumTopicFirstPost';
import ForumTopicComment from './ForumTopicComment';
import ForumTopicCommentCreate from './ForumTopicCommentCreate';
import ListFooter from '../../components/ListFooter/ListFooter';
import ContentModal from '../../components/Modals/ContentModal';
import ForumSearchBlock from './ForumSearchBlock';

export default class ForumTopic extends Component {
  static propTypes = {
    // prop: PropTypes,
  };

  constructor(props) {
    super(props);

    this.defaultPageSize = 10;

    this.state = {
      isLoading: true,
      isLoadingMore: false,
      searchQuery: '',
      page: 1,
      pageSize: this.defaultPageSize,
      mobileShowTextEditor: false,
      blockquote: '',
      blockquoteAuthor: '',
    };
  }

  componentWillMount = () => {
    this.getTopicData();
  };

  getTopicData = () => {
    this.setState({ isLoading: true });
    GetTopic(this.props.match.params.alias)
      .then((topic) => {
        this.setState({
          topic,
          comments: topic.comments.data,
          total: topic.comments.total,
        });
      })
      .catch(e => console.log(e))
      .finally(() => {
        this.setState(
          {
            isLoading: false,
          },
          this.getCategories,
        );
      });
  };

  reloadComments = (callback) => {
    this.setState(
      {
        mobileShowTextEditor: false,
        page: 1,
      },
      this.setResult,
    );
  };

  getCategories = () => {
    this.setState({ isLoading: true });
    GetCategoriesList()
      .then((result) => {
        this.setState(
          {
            categories: result,
          },
          this.setDefaultCategory,
        );
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  /**
   * @param {bool}  more   добавлять новые темы в список, а не перетирать их.
   */
  getComments = (id, take = 15, skip = 0, more = false) => {
    if (more) {
      this.setState({ isLoadingMore: true });
    } else {
      this.setState({ isLoading: true });
    }
    GetComments(id, take, skip)
      .then((result) => {
        if (more) {
          this.setState({
            comments: [...this.state.comments, ...result.data],
            total: result.total,
          });
        } else {
          this.setState({
            comments: result.data,
            total: result.total,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
          isLoadingMore: false,
        });
      });
  };

  handleSelectedCategoryChange = (selectedCategory) => {
    this.setState({ selectedCategory, searchQuery: '' }, this.setResult);
    this.props.history.push(`${paths.advocates.forumCategories}/${selectedCategory.alias}`);
  };

  setDefaultCategory = () => {
    if (this.state.topic) {
      this.setState({
        selectedCategory: this.state.topic.forumCategory,
      });
    }
  };

  handleSearchQueryChange = (e) => {
    const searchQuery = e.currentTarget.value;
    this.setState({ searchQuery });
  };

  handleMobileShowTextEditor = () => {
    this.setState({ mobileShowTextEditor: true }, () => this.scrollToCreateComment());
  }

  setResult = (more = false) => {
    if (this.state.showSearchResult) {
      this.search(
        this.state.searchQuery,
        'topic',
        this.state.topic.alias,
        this.state.pageSize,
        (this.state.page - 1) * this.state.pageSize,
        more,
      );
    } else {
      this.getComments(
        this.state.topic.id,
        this.state.pageSize,
        (this.state.page - 1) * this.state.pageSize,
        more,
      );
    }
  };

  search = (query, type, alias, take, skip, more) => {
    ForumSearch(query, type, alias, take, skip)
      .then((result) => {
        if (more) {
          this.setState({
            showSearchResult: true,
            requestedSearchQuery: query,
            searchResult: [...this.state.searchResult, ...result.data],
            searchTotal: result.total,
          });
        } else {
          this.setState({
            showSearchResult: true,
            searchResult: result.data,
            requestedSearchQuery: query,
            searchTotal: result.total,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
          isLoadingMore: false,
        });
      });
  };

  handleSearch = () => {
    const { searchQuery, showSearchResult } = this.state;
    if (searchQuery && searchQuery.trim && searchQuery.trim().length) {
      this.setState(
        {
          mobileShowTextEditor: false,
          showSearchResult: true,
          page: 1,
        },
        this.setResult,
      );
    } else if (showSearchResult) {
      this.setState(
        {
          mobileShowTextEditor: false,
          showSearchResult: false,
          searchQuery: [],
          searchTotal: null,
          page: 1,
        },
        this.setResult,
      );
    }
  };

  handleSearchEnterPress = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.handleSearch();
    }
  };

  handlePageClick = (e) => {
    const newPage = e.selected + 1;
    this.setState(
      {
        page: newPage,
        pageSize: this.defaultPageSize,
      },
      this.setResult,
    );
  };

  handleGetMorePosts = () => {
    this.setState(
      {
        isLoadingMore: true,
        page: this.state.page + 1,
      },
      () => this.setResult(true),
    );
  };

  setBlockquote = ({ text, author, callback }) => {
    this.setState({
      blockquote: text,
      blockquoteAuthor: author,
    }, () => (typeof callback === 'function' && callback()));
  };

  handleBlockquoteClear = () => {
    this.setState({
      blockquote: '',
      blockquoteAuthor: '',
    });
  };

  scrollToTopComment = () => {
    this.lastCommentOfPageRef.scrollIntoView({ behavior: 'instant' });
  };

  scrollToCreateComment = () => {
    this.commentCreateRef.scrollIntoView({ behavior: 'instant' });
  };

  getBlockquote = () => {
    const { blockquote, blockquoteAuthor } = this.state;
    return blockquote ? (
      <blockquote>
        <cite>{`${blockquoteAuthor} писал:`}</cite>
        <div dangerouslySetInnerHTML={{ __html: blockquote }} />
      </blockquote>
    ) : (
      ''
    );
  };

  render() {
    const { user } = this.props;
    const {
      isLoading,
      isLoadingMore,
      topic,
      comments,
      total,
      searchQuery,
      requestedSearchQuery,
      showSearchResult,
      searchResult,
      searchTotal,
      categories,
      selectedCategory,
      page,
      blockquote,
      blockquoteAuthor,
      mobileShowTextEditor
    } = this.state;
    if (isLoading || !topic || !selectedCategory) {
      return <Preloader />;
    }
    return (
      <div className="b-center bg-dragonfly5">
        <BreadCrumbs
          data={[
            { url: paths.advocates.main, text: 'Главная' },
            { url: paths.advocates.forum, text: 'Форум' },
            {
              url: `${paths.advocates.forumCategories}/${topic.forumCategory.alias}`,
              text: topic.forumCategory.title,
            },
          ]}
        />
        <h1 className="title -third">{topic.title}</h1>

        <ForumHeaderDesktop
          categories={categories}
          selectedCategory={selectedCategory}
          searchQuery={searchQuery}
          placeholder="Поиск по теме"
          handleSearchQueryChange={this.handleSearchQueryChange}
          handleSearch={this.handleSearch}
          handleSearchEnterPress={this.handleSearchEnterPress}
          handleSelectedCategoryChange={this.handleSelectedCategoryChange}
          renderSearchButton={false}
          renderDropdown
        >
          <button className="btn -secondary themes-search__button" onClick={this.handleSearch}>
            Поиск
          </button>
          <Link
            to={`${paths.advocates.forumCategories}/${selectedCategory.alias}`}
            className="btn themes-search__button"
          >
            Список тем
          </Link>
        </ForumHeaderDesktop>
        <ForumHeaderMobile
          categories={categories}
          selectedCategory={selectedCategory}
          searchQuery={searchQuery}
          handleSearchQueryChange={this.handleSearchQueryChange}
          handleSearch={this.handleSearch}
          handleSearchEnterPress={this.handleSearchEnterPress}
          handleSelectedCategoryChange={this.handleSelectedCategoryChange}
        >
          <button type="submit" className="search-block__button" onClick={this.handleSearch}>
            Поиск
          </button>
        </ForumHeaderMobile>

        {showSearchResult ? (
          <ForumSearchBlock searchQuery={requestedSearchQuery} searchResult={searchResult} />
        ) : (
          <React.Fragment>
            <div className="section-box theme">
              <ForumTopicFirstPost
                topic={topic}
                setBlockquote={this.setBlockquote}
                handleMobileShowTextEditor={this.handleMobileShowTextEditor}
              />
              <div ref={el => (this.lastCommentOfPageRef = el)} />

              {comments.map((item, i) => (
                <ForumTopicComment
                  key={item.id}
                  comment={item}
                  topic={topic}
                  setBlockquote={this.setBlockquote}
                  handleMobileShowTextEditor={this.handleMobileShowTextEditor}
                />
              ))}
              {isLoadingMore ? <Preloader /> : ''}

              {topic.isOpen ? (
                <ForumTopicCommentCreate
                  user={user}
                  userId={topic.userId}
                  topic={topic}
                  reloadComments={this.reloadComments}
                  history={this.props.history}
                  scrollToTopComment={this.scrollToTopComment}
                  blockquote={renderToString(this.getBlockquote())}
                  blockquoteAuthor={blockquoteAuthor}
                  handleBlockquoteClear={this.handleBlockquoteClear}
                  mobileShowTextEditor={mobileShowTextEditor}
                  handleMobileShowTextEditor={this.handleMobileShowTextEditor}
                />
              ) : (
                <div className="theme__post">
                  <div className="theme__post-author">&nbsp;</div>
                  {'Тема закрыта для обсуждения'}
                </div>
              )}
            </div>
            {!mobileShowTextEditor && (
              <div className="mobile-show700">
                <button
                  className="btn theme__post-button w100pr"
                  onClick={this.handleMobileShowTextEditor}
                >
                  {'Написать сообщение'}
                </button>
              </div>
            )}
            <div ref={el => (this.commentCreateRef = el)} />
          </React.Fragment>
        )}
        <ListFooter
          counterLabel="комментариев"
          pageSize={this.defaultPageSize}
          total={showSearchResult ? searchTotal : total}
          handlePageClick={this.handlePageClick}
          handleLoadMore={this.handleGetMorePosts}
          currentPage={page}
        />
      </div>
    );
  }
}
